// frontend / src / slices / usersApiSlice.js
import { USERS_URL } from '../constans';
import { apiSlice } from './apiSlice';

const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateBotCode: builder.mutation({
      query: () => ({
        url: '/api/users/profile/bot-code', // Эндпоинт, который мы напишем на сервере позже
        method: 'POST',
      }),
    }),
    getUsers: builder.query({
      query: () => ({
        url: USERS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // login: builder.mutation({
    //   query: (data) => ({
    //     url: `${USERS_URL}/login`,
    //     method: 'POST',
    //     body: data,
    //   }),
    //   keepUnusedDataFor: 5,
    // }),
    login: builder.mutation({
      query: (data) => {
        // Логируем данные, которые передаются в запрос
        // console.log('Login data:', data);

        // Логируем URL, который будет использоваться для запроса
        // console.log('Base URL:', `${BASE_URL}`);
        // Логируем URL, который будет использоваться для запроса
        // console.log('Request URL:', `${USERS_URL}/login`);

        // const fullUrl = `${process.env.REACT_APP_BASE_URL_PROD}${USERS_URL}/login`;
        // console.log('fullUrl:', `${fullUrl}`);


        return {
          url: `${USERS_URL}/login`,
          method: 'POST',
          body: data,
          credentials: 'include',
        };

        // `credentials` — это параметр, используемый в Fetch API и XMLHttpRequest для управления тем,// чтобы браузер отправлял и принимал cookie
        //`credentials` — это параметр, используемый в Fetch API и XMLHttpRequest для управления тем, 
        // как браузер обрабатывает cookie и другие учетные данные(например, заголовки авторизации) 
        // при выполнении запросов.Вот различия между значениями `'include'` и`'same-origin'`:
        //'include' - браузер будет отправлять cookie и другие учетные данные с запросами, 
        //            независимо от того, являются ли они кросс-доменными или нет
        //            Использование include: - когда вам нужно отправлять cookie в кросс-доменных запросах, 
        //            например, при взаимодействии с API, размещенными на другом домене. 
        //            Оно обеспечивает полное взаимодействие между клиентом и сервером, включая авторизацию и сохранение сессий.
        //'same-origin' - браузер будет отправлять cookie и другие учетные данные только в том случае, 
        //            если запросы выполняются в пределах одного и того же домена (то есть, не кросс-доменные запросы).
        //            Использование: - вы хотите ограничить отправку учетных данных только запросами, 
        //            выполняемыми в пределах одного домена.Это может быть полезно для повышения безопасности, 
        //            предотвращая отправку cookie в кросс - доменных запросах
      },
    }),
    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}`,
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
    getUserById: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getProfile: builder.query({
      query: () => ({
        url: `${USERS_URL}/profile`,
      }),
      keepUnusedDataFor: 5,
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/profile`,
        method: 'PUT',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/`,
        method: 'PATCH',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
        method: 'DELETE',
      }),
      keepUnusedDataFor: 5,
    }),
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`, //    /api/users
        method: 'POST',
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useRegisterMutation,
  useGetUsersQuery,
  useGetProfileQuery,
  useGetUserByIdQuery,
  useLoginMutation,
  useUpdateProfileMutation,
  useDeleteUserMutation,
  useLogoutMutation,
  useUpdateUserMutation,
  useGenerateBotCodeMutation,
} = usersApiSlice;
